module.exports = __webpack_public_path__ + "img/9_67.35826e92.png";